<template>
  <div class="results container">
    <div class="d-flex justify-content-between align-items-center" style="height:74px;">
      <div>
        <router-link class="search-link text-primary py-1" to="/">
          <small>
            <i v-if="hebrew" class="fa fa-arrow-right"></i>
            <i v-else class="fa fa-arrow-left"></i>
            {{hebrew ? 'טען טקסט חדש' : 'Submit New Text'}}         
          </small>
        </router-link>
        <br>
        <small v-if="hebrew">
          מציג {{resultsNum}} <span v-if="!resultsLong">שורות</span> 
          <span v-if="resultsLong">שורות מתוך {{totalResults}} שורות</span>
          ({{textTypeHebrew}})
        </small> 
        <small v-else>
          Displaying {{resultsNum}}  <span v-if="!resultsLong">lines</span>
          <span v-if="resultsLong">out of {{totalResults}} lines</span>
          <span class="text-capitalize"> ({{textType}} text)</span>
        </small>        
      </div>  
      <download-results></download-results>
    </div> 
    <result-table></result-table>
  </div>
</template>

<script>
import ResultTable from "@/components/ResultTable"
import DownloadResults from "@/components/DownloadResults"
export default {
  name: 'Results',
  components: { 
    ResultTable,
    DownloadResults
  },
  data() {
    return {
      
    }
  },  
  props: {
    
  },
  mounted: function() {
    
  },
  computed: {   
    hebrew () {
      return this.$settings.hebrew
    },
    bguLength () {      
      return this.$store.state.results[0] ? this.$store.state.results[0].BGU.split('\n').filter(el=>el).length-1 : 0
    },
    udlength () {
      return this.$store.state.results[0].UD.split('\n').length
      //.filter(ln => {return !ln.includes('#')}).length
    },
    displayedLines () {
      return this.udFormat ? this.$store.state.UDarr.length : 100
    },
    udFormat () {
      return this.$store.state.fileFormat.includes('UD')
    },
    totalResults () {
      return this.udFormat ? this.udlength : this.bguLength
    },
    resultsLong () {
      return this.udFormat ? this.displayedLines > 100 : this.totalResults > this.displayedLines
    },     
    resultsNum () {
      return this.totalResults > this.displayedLines ? this.displayedLines : this.totalResults
    },
    textType () {
      return this.$store.state.textStyle
    },
    textTypeHebrew () {
      var selectedText = 'טקסט רבני'
      switch (this.textType) {
        case 'modern':
          selectedText = 'טקסט מודרני' 
          break;
        case 'premodern':
          selectedText = 'טקסט קדם מודרני' 
          break;          
      }
      return selectedText
    }
  }
}
</script>
<style >
  .search-link:hover {
    text-decoration: none;
  }
</style>